const initBootstrapDropdown = async () => {
    // Dynamic import
    const elements = document.querySelectorAll('.dropdown-toggle');
    if (! elements.length) {
        return;
    }
    const {default: Dropdown} = await import('bootstrap/js/dist/dropdown');
    //  Instantiation
    const dropdownElementList = [].slice.call(elements);
    dropdownElementList.map(function (dropdownToggleEl) {
        return new Dropdown(dropdownToggleEl);
    });
};

export default class BootstrapDropdown {

    static init() {
        initBootstrapDropdown();
    }

}
